import React, { Component } from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-1711">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-1712">
      <span className="block text-sm font-normal mb-1" data-id="element-1713">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-1714">Start de cursus nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-1715" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-1716">
    <h3 className="text-[#5ce0d2] font-extrabold text-xl md:text-2xl mb-1 uppercase tracking-wide" data-id="element-1717">
      Liefdevol Communiceren
    </h3>
    <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-1718">
      Pakket Actie
    </h2>

    <div className="mb-6" data-id="element-1719">
      <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-1720" />
    </div>

    {/* What's included */}
    <div className="text-left space-y-2 mb-6 bg-[#faf5eb] rounded-lg p-4" data-id="element-1721">
      <div className="flex items-start gap-2" data-id="element-1722">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1723" />
        <p className="text-sm text-gray-700" data-id="element-1724">
          <span className="font-bold" data-id="element-1725">Liefdevol Communiceren Cursus</span>{' '}
          <span className="text-gray-500" data-id="element-1726">(€197)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-1727">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1728" />
        <p className="text-sm text-gray-700" data-id="element-1729">
          <span className="font-bold" data-id="element-1730">2 gratis aanvullende cursussen</span> naar
          keuze <span className="text-gray-500" data-id="element-1731">(€160)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-1732">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1733" />
        <p className="text-sm text-gray-700" data-id="element-1734">
          <span className="font-bold" data-id="element-1735">Digitaal boek "Wat Zegt Jouw Hond?"</span>{' '}
          <span className="text-gray-500" data-id="element-1736">(€44)</span>
        </p>
      </div>
    </div>

    <div className="text-gray-500 text-base mb-1" data-id="element-1737">
      Totale waarde: <span className="line-through" data-id="element-1738">€401</span>
    </div>
    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1739">Nu voor €127</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-1740">(Bespaar €274)</div>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-1741">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-1742" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-1743">
      <p className="flex items-center justify-center gap-1" data-id="element-1744">
        <Lock className="w-4 h-4" data-id="element-1745" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-1746">
        <ShieldCheck className="w-4 h-4" data-id="element-1747" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
const PakketActieSection = () => {
  const cursussen = [{
    title: 'Cursus Uitvallen',
    desc: 'Voor honden die uitvallen naar andere honden of mensen tijdens het wandelen.',
    icon: '🐕'
  }, {
    title: 'Cursus Stress bij Wandelen',
    desc: 'Help je hond ontspannen tijdens elke wandeling, ook in drukke omgevingen.',
    icon: '🚶'
  }, {
    title: 'Cursus Overmatig Blaffen',
    desc: 'Ontdek waarom je hond blaft en hoe je dit op een liefdevolle manier vermindert.',
    icon: '🔊'
  }, {
    title: 'Puppycursus',
    desc: 'Begin je puppy-leven goed met de juiste basis in communicatie en vertrouwen.',
    icon: '🐶'
  }, {
    title: 'Cursus Opspringen',
    desc: 'Leer je hond rustig te begroeten zonder springen, zonder corrigeren.',
    icon: '🦴'
  }, {
    title: 'Cursus Verlatingsangst',
    desc: 'Help je hond ontspannen alleen thuis te zijn, stap voor stap.',
    icon: '🏠'
  }, {
    title: 'Cursus Geluidsangst',
    desc: 'Ondersteun je hond bij vuurwerk, onweer en andere harde geluiden.',
    icon: '⚡'
  }];
  return <section className="bg-[#faf5eb] py-16 md:py-20" data-id="element-1748">
      <div className="max-w-6xl mx-auto px-4" data-id="element-1749">
        <div className="text-center mb-12" data-id="element-1750">
          <span className="inline-block bg-[#e53e3e] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-1751">
            Pakket Actie - Tijdelijk Aanbod
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-[#1a2b4a] mb-4" data-id="element-1752">
            Dit krijg je allemaal voor{' '}
            <span className="text-[#e53e3e]" data-id="element-1753">€127</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1754">
            Niet alleen de Liefdevol Communiceren Cursus, maar een compleet
            pakket dat jou en je hond op elk vlak ondersteunt - met een totale
            waarde van{' '}
            <span className="font-bold line-through text-gray-500" data-id="element-1755">€401</span>.
          </p>
        </div>

        {/* 3 Components Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1756">
          {/* 1. Hoofdcursus */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-1757">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1758">
              Onderdeel 1
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1759">
              <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus" className="w-full h-32 object-contain mb-4" data-id="element-1760" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1761">
                Liefdevol Communiceren Cursus
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1762">
                De complete online cursus waarin je leert de taal van je hond te
                begrijpen en zelf liefdevol terug te communiceren.
              </p>
              <div className="text-right" data-id="element-1763">
                <span className="text-gray-400 line-through" data-id="element-1764">€197</span>
              </div>
            </div>
          </div>

          {/* 2. Twee cursussen */}
          <div className="bg-white rounded-2xl shadow-md border-2 border-[#ffb800] overflow-hidden flex flex-col relative" data-id="element-1765">
            <div className="bg-[#ffb800] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1766">
              Onderdeel 2 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1767">
              <div className="w-full h-32 flex items-center justify-center mb-4 bg-gradient-to-br from-[#e6f7f5] to-[#faf5eb] rounded-lg" data-id="element-1768">
                <div className="text-5xl" data-id="element-1769">🎁</div>
              </div>
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1770">
                2 Aanvullende Cursussen naar keuze
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1771">
                Kies tijdens het afrekenen 2 cursussen uit de lijst hieronder
                die het beste bij jouw situatie passen.
              </p>
              <div className="text-right" data-id="element-1772">
                <span className="text-gray-400 line-through" data-id="element-1773">€160</span>
              </div>
            </div>
          </div>

          {/* 3. Boek */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-1774">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1775">
              Onderdeel 3 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1776">
              <img src="https://cdn.magicpatterns.com/uploads/6GVCL5WQtpsTAWZp3DJ7Rr/boek_mockup_wat_zegt_jouw_hond_(2).png" alt='Boek "Wat Zegt Jouw Hond?"' className="w-full h-32 object-contain mb-4" data-id="element-1777" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1778">
                Boek "Wat Zegt Jouw Hond?"
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1779">
                De digitale versie van ons boek over hondentaal. Voor op je
                mobiel, tablet, computer of om uit te printen.
              </p>
              <div className="text-right" data-id="element-1780">
                <span className="text-gray-400 line-through" data-id="element-1781">€44</span>
              </div>
            </div>
          </div>
        </div>

        {/* Choose 2 from 7 */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-10 mb-10" data-id="element-1782">
          <div className="text-center mb-8" data-id="element-1783">
            <h3 className="text-2xl md:text-3xl font-black text-[#1a2b4a] mb-3" data-id="element-1784">
              Kies tijdens het afrekenen 2 cursussen naar keuze
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1785">
              Welke uitdaging ervaar jij met je hond? Tijdens het afrekenen
              krijg je de keuze uit deze 7 cursussen - kies de 2 die jij
              waardevol vindt.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1786">
            {cursussen.map((c, i) => <div key={i} className="bg-[#faf5eb] rounded-xl p-4 border border-gray-100 hover:border-[#5ce0d2] transition-colors flex gap-3 items-start" data-id="element-1787">
                <div className="text-3xl flex-shrink-0" data-id="element-1788">{c.icon}</div>
                <div data-id="element-1789">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-1" data-id="element-1790">
                    {c.title}
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-1791">
                    {c.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-sm text-gray-500 mt-6 italic" data-id="element-1792">
            Twijfel je nog? Geen zorgen - je kunt je keuze tijdens het afrekenen
            rustig maken.
          </p>
        </div>

        {/* Summary + CTA */}
        <div className="bg-[#1a2b4a] rounded-2xl p-8 md:p-12 text-center text-white shadow-xl" data-id="element-1793">
          <p className="text-sm uppercase tracking-wider text-[#5ce0d2] font-bold mb-3" data-id="element-1794">
            Het Liefdevol Communiceren Pakket
          </p>
          <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-1795">
            Cursus + 2 vrije cursussen + boek
          </h3>
          <div className="flex flex-col items-center mb-6" data-id="element-1796">
            <span className="text-lg text-gray-400 line-through mb-1" data-id="element-1797">
              Totale waarde €401
            </span>
            <span className="text-5xl md:text-6xl font-black text-[#ffb800]" data-id="element-1798">
              €127
            </span>
            <span className="text-[#5ce0d2] font-bold text-lg mt-1" data-id="element-1799">
              Je bespaart €274
            </span>
          </div>
          <div className="max-w-md mx-auto" data-id="element-1800">
            <CTAButton data-id="element-1801" />
          </div>
          <div className="text-xs text-gray-400 mt-6 flex flex-wrap items-center justify-center gap-4" data-id="element-1802">
            <span className="flex items-center gap-1" data-id="element-1803">
              <Lock className="w-4 h-4" data-id="element-1804" /> 100% veilig afrekenen
            </span>
            <span className="flex items-center gap-1" data-id="element-1805">
              <ShieldCheck className="w-4 h-4" data-id="element-1806" /> 365 dagen geld-terug
            </span>
          </div>
        </div>
      </div>
    </section>;
};
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-1807">
      {/* 1. HEADER */}
      <div className="bg-white py-3 px-4" data-id="element-1808">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1809">
          <div className="flex-1 hidden md:block" data-id="element-1810"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-1811" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-1812">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-1813">
              <Mail className="w-5 h-5 mr-2" data-id="element-1814" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </div>
      </div>

      {/* 2. SUB BANNER */}
      <div className="bg-[#EDEDED] text-[#1a2b4a] text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-1815">
        Voor baasjes die eindelijk de verborgen taalbarrière met hun hond willen
        doorbreken (en een echte, diepe band willen opbouwen)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-1816">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-1817">
          Jouw hond is niet 'koppig' of 'ongehoorzaam' - je spreekt zijn taal
          niet. Ontdek hoe je vloeiend de hondentaal leert spreken in 3 stappen.
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-1818">
          Zodat jij je hond écht begrijpt, je probleemgedrag kan stoppen zonder
          straffen of corrigeren en jullie de meest liefdevolle band krijgen die
          je als baasje met je hond kan hebben.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-1819">
          <div className="md:col-span-8" data-id="element-1820">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-1821">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1822">
                <iframe src="https://player.vimeo.com/video/1099360202?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-1823"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-1824">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-1825">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-1826">
                Wat is de Liefdevol Communiceren Methode?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-1827">
                <p data-id="element-1828">
                  De Liefdevol Communiceren Methode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de verborgen taal van hun hond te
                  leren lezen, te begrijpen en zelf vloeiend terug te spreken.
                </p>
                <p data-id="element-1829">
                  We laten je precies zien hoe jouw hond de hele dag met je
                  communiceert via subtiele lichaamssignalen, en hoe jij op een
                  manier terugpraat die hij van nature begrijpt - zonder dwang,
                  straf of dominantie.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-1830">
                  Zodat jullie relatie niet gebaseerd is op gehoorzaamheid, maar
                  op wederzijds begrip en vertrouwen. (Waardoor je hond naar je
                  gaat luisteren omdat die je begrijpt, je vertrouwt en je
                  respecteert).
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-1831">
            <PricingCard data-id="element-1832" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1833">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-1834">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1835">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-1836">
            Voor alle baasjes die worstelen met gedragsproblemen en het gevoel
            hebben dat ze hun hond niet echt begrijpen:
          </p>
          <ul className="space-y-4" data-id="element-1837">
            {['Het maakt niet uit als je nog nooit eerder iets hebt geleerd over hondentaal of lichaamssignalen.', 'De methode is eenvoudig en direct toepasbaar. Met slechts 30 minuten per dag zie je binnen een week al de eerste verbeteringen, en binnen twee tot vier weken ontstaat er een compleet nieuwe relatie.', 'Geschikt voor honden van alle leeftijden, rassen en formaten.', 'Werkt ook bij angstige honden, overprikkelde honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1838">
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-1839" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1840">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Desire Stack */}
          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-1841">
            <h4 className="text-xl font-bold text-[#1a2b4a] mb-4" data-id="element-1842">
              Stel je voor dat je straks…
            </h4>
            <ul className="space-y-3" data-id="element-1843">
              {['Precies weet hoe je je hond op zijn gemak stelt als hij onrustig wordt - zonder te schreeuwen of te corrigeren.', 'Zijn stresssignalen herkent vóórdat het escaleert, zodat je hem kunt geruststellen op het moment dat hij het nodig heeft.', 'Ontspannen kunt wandelen zonder constant alert te zijn op andere honden of mensen.', "Zonder commando's communiceert met je hond, gewoon door je lichaamstaal - en hij begrijpt je meteen.", 'Visite kunt ontvangen zonder dat je hond door het lint gaat of dat jij je moet verontschuldigen.', 'Eindelijk die diepe, rustige band voelt waar je altijd van hebt gedroomd - elke dag opnieuw.'].map((item, i) => <li key={`desire-${i}`} className="flex items-start" data-id="element-1844">
                  <Star className="w-5 h-5 text-[#ffb800] mr-3 flex-shrink-0 mt-0.5" data-id="element-1845" />
                  <span className="text-gray-700 text-lg" data-id="element-1846">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1847">
          Met de Liefdevol Communiceren Methode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1848">
          <p data-id="element-1849">
            ...leer je in drie stappen de taal van je hond te lezen én te
            spreken, zodat jullie eindelijk op één lijn zitten en
            gedragsproblemen vanzelf verminderen.
          </p>
          <p data-id="element-1850">
            Waardoor je hond zich begrepen voelt en jullie samenwerking soepeler
            gaat dan je ooit voor mogelijk hield.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-1851">
            Geen frustratie meer dat je alles hebt geprobeerd maar niets werkt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-1852">
          <img src="https://cdn.magicpatterns.com/uploads/fGHv8ypZfDoYKf4ChjPLqb/IMG-20171008-WA0012.jpg" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-1853" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-1854">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1855">
            Herken jij dit bij jouw hond?
          </h3>
          <ul className="space-y-4" data-id="element-1856">
            {['Springt tegen visite op, blaft de bezorger af, of wordt helemaal gek als er iemand aan de deur komt', 'Trekt als een bezetene aan de lijn of valt uit naar andere honden tijdens het wandelen', 'Pakt eten van tafel, luistert niet als je hem roept, of negeert je compleet in het park', 'Is constant druk in huis, kan niet tot rust komen op zijn plek, of volgt je overal naartoe', 'Reageert angstig op geluiden, nieuwe plekken of onbekende mensen - en jij weet niet hoe je hem gerust kunt stellen', 'Het gevoel dat je alles al hebt geprobeerd, maar dat jullie nog steeds langs elkaar heen leven', 'Hij vertrouwt je niet echt'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1857">
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-1858" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1859">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-lg font-bold text-[#1a2b4a]" data-id="element-1860">
            Dan is deze cursus voor jou.
          </p>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-1861">
        <div className="max-w-4xl mx-auto px-4" data-id="element-1862">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-1863">
            <div data-id="element-1864">
              <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-1865">
                Liefdevol Communiceren
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-4" data-id="element-1866">
                Pakket Actie
              </h2>
              <div className="text-gray-500 text-base mb-1" data-id="element-1867">
                Totale waarde: <span className="line-through" data-id="element-1868">€401</span>
              </div>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1869">
                Nu voor €127
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-1870">
                (Bespaar €274)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1871">
                Start met het Liefdevol Communiceren Pakket voor €127. Inclusief
                2 gratis aanvullende cursussen naar keuze en het digitale boek
                "Wat Zegt Jouw Hond?". Per direct toegang.
              </p>
            </div>
            <div data-id="element-1872">
              <CTAButton data-id="element-1873" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-1874">
                <p className="flex items-center justify-center gap-1" data-id="element-1875">
                  <Lock className="w-4 h-4" data-id="element-1876" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-1877">
                  <ShieldCheck className="w-4 h-4" data-id="element-1878" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PakketActieSection data-id="element-1879" />

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-1880">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-1881">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-1882">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-1883">
              Hij luistert wel, maar begrijpt je niet
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1884">
              <p data-id="element-1885">
                Een commando heeft pas zin als je eerst dezelfde taal spreekt
                als je hond.
              </p>
              <p data-id="element-1886">
                Doe je dat niet, dan blijft er een onzichtbare muur tussen
                jullie staan. Je hond snapt niet wat je tegen hem zegt, en jij
                begrijpt niet waarom. Want jullie spreken letterlijk een andere
                taal.
              </p>
              <p data-id="element-1887">
                Jouw hond communiceert de hele dag subtiele signalen. Dat je die
                soms mist, is niet jouw schuld. De ouderwetse hondenindustrie
                heeft ons decennialang verteld dat honden gewoon moeten
                'luisteren', in plaats van ons te leren hoe we hun taal kunnen
                lezen.
              </p>
              <p data-id="element-1888">
                Oude trainingsmethodes laten je geloven dat je hond 'koppig' of
                'dominant' is als die niet luistert, terwijl jullie in
                werkelijkheid elkaar niet begrijpen. Zodra je weet hoe je op een
                manier communiceert die hij vanuit zijn natuur snapt, valt die
                frustratie direct weg.
              </p>
              <p className="font-medium" data-id="element-1889">
                Daarom moet je eerst de taalbarrière doorbreken. Dit is hoe het
                werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-1890">
              <img src="https://cdn.magicpatterns.com/uploads/43tvVR32w9VpvEgS87mE9U/liefdevol_vergelijking_v4.png" alt="Oude Aanpak vs De Liefdevol Communiceren Methode" className="w-1/2 h-auto object-contain rounded-lg mx-auto" data-id="element-1891" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-1892">
              De taalbarrière doorbreken in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-1893">
              {[{
              title: 'Stap 1: Hondentaal',
              text: 'De eerste stap is de taal van je hond leren. Je hond communiceert de hele dag via subtiele lichaamssignalen. In stap 1 leer je deze signalen herkennen en begrijpen, zodat je eindelijk weet wat je hond je probeert te vertellen.'
            }, {
              title: 'Stap 2: Terugpraten',
              text: 'De tweede stap is zelf in die taal terugpraten. Je leert hoe je met handgebaren en lichaamstaal signalen communiceert op een manier die je hond van nature begrijpt. Geen geschreeuw, geen straffen - gewoon duidelijke, liefdevolle communicatie die hij meteen oppikt.'
            }, {
              title: 'Stap 3: Samenwerken',
              text: 'En dan, als jullie dezelfde taal spreken… Ga je als derde stap écht samenwerken. Niet meer commanderen en gehoorzamen, maar een gelijkwaardige samenwerking gebaseerd op begrip en vertrouwen. Gedragsproblemen lossen zichzelf op, want de oorzaak - miscommunicatie - is verdwenen.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-1894">
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-1895">
                    {i + 1}
                  </div>
                  <div data-id="element-1896">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1897">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-1898">
              Op deze manier kan zelfs een hond die al jaren uitvalt, blaft of
              trekt leren om rustig en ontspannen te zijn - omdat hij zich
              eindelijk begrepen voelt en jij eindelijk begrijpt wat hij nodig
              heeft.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-1899">
              Zonder frustratie, zonder straffen, zonder dominantie.
            </p>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-1900">
              Zo pas je de Liefdevol Communiceren Methode vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-1901">
              De Liefdevol Communiceren Methode is uniek in Nederland.
              Hondenscholen werken nog niet op deze manier. Maar wij vinden dat
              ieder hondenbaasje dat worstelt met de gedragsproblemen van zijn
              hond, of die zijn hond simpelweg beter wilt begrijpen, de kans zou
              moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-1902">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we de drie essentiële stappen in deze aanpak.
              Dit doen we met een rustige uitleg, praktijkvoorbeelden en
              printbaar lesmateriaal.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-1903">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de subtiele lichaamssignalen van je hond en hoe je deze leest, zodat je zeker weet wat hij je probeert te vertellen.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je met handgebaren en je lichaam in hondentaal terugpraat, zodat je hond jou begrijpt en klaar is voor stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe jullie als een team kunnen samenwerken, zodat gedragsproblemen vanzelf verdwijnen.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-1904">
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-1905">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1906">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-1907">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-1908">
            <div className="sticky top-8" data-id="element-1909">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-1910">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-1911">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-1912">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-1913">
                    <img src="https://cdn.magicpatterns.com/uploads/4wUNXnqn4DFV4J3eFkdeE5/lc_book_mockup.png" alt="Liefdevol Communiceren - Cursus" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-1914" />
                    <div data-id="element-1915">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1916">
                        LIEFDEVOL COMMUNICEREN - CURSUS
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1917">
                        Gedetailleerde uitleg van hoe je de verborgen
                        taalbarrière in 3 stappen doorbreekt en een diepe band
                        opbouwt
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-1918">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1919">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1920" />
                    <div data-id="element-1921">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1922">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1923">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1924">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Printbare Stappenplannen" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1925" />
                    <div data-id="element-1926">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1927">
                        Printbare Stappenplannen
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1928">
                        Handige, printbare overzichten van alle lichaamssignalen
                        en kalmerende signalen om er altijd bij te kunnen
                        pakken.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-1929">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Levenslange Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1930" />
                    <div data-id="element-1931">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1932">
                        Levenslange Toegang
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1933">
                        Je krijgt levenslange toegang tot al het lesmateriaal,
                        inclusief alle toekomstige updates van de cursus.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-1934">
                    RESULTATEN VAN DE METHODE
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-1935">
                    <div style={{
                    padding: '112.5% 0 0 0',
                    position: 'relative'
                  }} data-id="element-1936">
                      <iframe src="https://player.vimeo.com/video/1084988962?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-1937"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-1938">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1939">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-1940">
            RESULTATEN VAN DE METHODE
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-1941">
            Dit is hoe ik hondenbaasjes help om de taalbarrière te doorbreken
            door eerst de hondentaal te leren, dit maakt de verdere samenwerking
            veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-1942">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Liefdevol Communiceren Methode
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-1943">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-1944">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-1945">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-1946">
                  <p className="font-bold" data-id="element-1947">Beste hondenbaasje,</p>
                  <p data-id="element-1948">
                    <strong data-id="element-1949">Van:</strong> Amee de Bruijn
                  </p>
                  <p data-id="element-1950">
                    <strong data-id="element-1951">Re:</strong> De enige manier om gedragsproblemen
                    écht op te lossen, is door de taal van je hond te spreken
                    (en niet door te commanderen).
                  </p>
                  <p data-id="element-1952">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos corrigeren waarmee je gedragsproblemen sneller
                    kunt oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-1953">En dat is niet gek.</p>
                  <p data-id="element-1954">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: commando's, correcties, je hond
                    domineren, of afleiden met snoepjes.
                  </p>
                  <p data-id="element-1955">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-1956">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-1957">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-1958">
                    <strong data-id="element-1959">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Deze verandering vraagt erom dat je anders gaat kijken naar
                    je hond. Op een lievere, empatischere manier waarin je hond
                    geen robot is die zomaar bevelen op zou moeten volgen. Maar
                    meer een volwaardig gezinslid van een gezin waar jij aan het
                    hoofd staat. Als je er niet toe bereid bent zo naar je hond
                    te kijken, dan is deze methode misschien niet voor jou. Met
                    dat gezegd, laat me je laten zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-1960">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-1961">
                    Dit is dezelfde Liefdevol Communiceren Methode die duizenden
                    hondeneigenaren nu gebruiken om onbegrip, irritaties en
                    problemen met hun hond écht op te lossen.
                  </p>
                  <p data-id="element-1962">
                    Hierdoor krijgen zij een ontspannen hond terug, sneller dan
                    ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-1963">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-1964">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-1965">
                    Het is een fundamenteel andere manier van samenleven met je
                    hond. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1966">
                    <li data-id="element-1967">
                      Eindeloze gehoorzaamheidstrainingen die nergens toe
                      leiden.
                    </li>
                    <li data-id="element-1968">
                      Je hond straffen of corrigeren als hij iets 'fout' doet.
                    </li>
                    <li data-id="element-1969">Trucjes om je hond af te leiden met voer.</li>
                    <li data-id="element-1970">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-1971">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met het leren van de taal van de hond zodat jullie
                    elkaar echt gaan begrijpen.
                  </p>
                  <p data-id="element-1972">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1973">
                    Hoe ik dit ontdekte: De "Muur van Onbegrip" bij mijn klanten
                  </h3>
                  <p data-id="element-1974">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Muur van Onbegrip":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-1975">
                    <p data-id="element-1976">
                      <strong data-id="element-1977">Stap 1:</strong> Ze volgden online adviezen en
                      begonnen met strenge commando's en correcties.
                    </p>
                    <p data-id="element-1978">
                      <strong data-id="element-1979">Stap 2:</strong> De hond luisterde niet, dus ze
                      proberen strenger te zijn. Meer correcties.
                    </p>
                    <p data-id="element-1980">
                      <strong data-id="element-1981">Stap 3:</strong> Na een week leek de hond even te
                      luisteren uit angst. Een klein succes!
                    </p>
                    <p data-id="element-1982">
                      <strong data-id="element-1983">Stap 4:</strong> Maar het streng zijn voelt niet
                      fijn voor het baasje en is niet altijd consistent. Wat
                      weer verwarrend is voor de hond.
                    </p>
                    <p data-id="element-1984">
                      <strong data-id="element-1985">Stap 5:</strong> De hond onderdrukt deels zijn
                      reacties en de hele situatie levert hem stress op.
                    </p>
                    <p data-id="element-1986">
                      <strong data-id="element-1987">Stap 6:</strong> Stress bij de hond bouwt op
                      waardoor hij reactief wordt. Hij reageert ineens heftig op
                      straat, wordt angstig of gaat ander "probleemgedrag"
                      vertonen.
                    </p>
                    <p data-id="element-1988">
                      <strong data-id="element-1989">Stap 7:</strong> Met dit nieuwe gedrag beginnen ze
                      weer bij stap 1 (en voelen zich een slechte baas).
                    </p>
                  </div>
                  <p data-id="element-1990">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-1991">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen en het voelde slecht.
                  </p>
                  <p data-id="element-1992">
                    Ik stond op het punt om te geloven dat sommige honden gewoon
                    onhandelbaar waren en het vak als hondengedragsdeskundige
                    niks voor mij was.
                  </p>
                  <p data-id="element-1993">
                    Maar voordat ik opgaf, kwam ik in aanraking met een nieuwe
                    methode. En deze methode veranderde alles voor mij.
                  </p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-1994">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-1995" />
                    <div data-id="element-1996">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1997">
                        Mijn naam is Amee, en ik ken de frustratie als baasje.
                      </h3>
                      <div className="space-y-4" data-id="element-1998">
                        <p className="text-sm text-[#5ce0d2] font-bold uppercase tracking-wide" data-id="element-1999">
                          Gediplomeerd Hondengedragsconsultant & Natural Dog
                          Trainer (niveau 5, Calming Signs, 2017)
                        </p>
                        <p data-id="element-2000">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde die ze van hun baasje
                          krijgen nog steeds problemen hebben.
                        </p>
                        <p data-id="element-2001">
                          Eigenaren die alles voor hun hond over hebben, maar
                          waarvan de hond nog steeds niet altijd lekker in zijn
                          vel zit.
                        </p>
                        <p data-id="element-2002">
                          Geen ontspannen wandeling, altijd die knoop in je maag
                          als je een andere hond tegenkomt, reactieve hond die
                          reageert op alles buiten het huis, heftige reactie op
                          visite, en nog meer...
                        </p>
                        <p data-id="element-2003">
                          Na jarenlange ervaring met honderden honden en hun
                          baasjes, en een specialisatie in natuurlijk
                          hondengedrag en hondenlichaamstaal, ontwikkelde ik een
                          methode die niet draait om gehoorzaamheid, maar om
                          wederzijds begrip.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-2004">
                    Keer op keer zag ik dat de standaard aanpak niet echt hielp.
                  </p>
                  <p data-id="element-2005">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen het gedrag niet opgelost met de
                    standaard aanpak die ik toen ook nog toepaste.
                  </p>
                  <p data-id="element-2006">
                    Pas toen we alles loslieten, volledig stopten met
                    conditioneren en begonnen met het echt kijken naar zijn
                    signalen en wat hij nodig had - gebeurde er iets magisch.
                    Het probleemgedrag verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-2007">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-2008">
                    Ongehoorzaamheid was niet het probleem; het was een
                    symptoom.
                  </p>
                  <p data-id="element-2009">En die kijk maakt het verschil in alles dat ik doe.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-2010">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-2011">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "africhters" en je hebt de "liefdevolle
                    hondenouders". Wij van Stressless Dogs zijn dat laatste. Wij
                    geloven dat je als hondenbaasje eigenlijk geen echte "baas"
                    bent over je hond, maar meer een liefdevolle ouder.
                  </p>
                  <p data-id="element-2012">
                    Maar jarenlang was ik ook een africhter. Ik probeerde mijn
                    klanten te helpen door het blaffen, piepen en slopen af te
                    leren...
                  </p>
                  <p data-id="element-2013">
                    Alleen het probleem is niet het gedrag zelf. Het probleem is
                    waar het gedrag vandaan komt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-2014">
                    Het gevaarlijkste advies dat je kunt krijgen, is "strenger
                    en consistent zijn".
                  </p>
                  <p data-id="element-2015">
                    Waarom? Omdat honden wel willen samenwerken, maar vaak niet
                    snappen wat van hen verwacht wordt omdat het baasje
                    verkeerde signalen met zijn lichaam afgeeft.
                  </p>
                  <p data-id="element-2016">Door deze miscommunicatie krijgt de hond stress.</p>
                  <p data-id="element-2017">
                    En deze stress bouwt op en zorgt voor meer probleemgedrag.
                  </p>
                  <p data-id="element-2018">
                    Opgebouwde stress zorgt ervoor dat je hond reactief wordt,
                    sneller blaft naar voorbijgangers, aan de lijn gaat trekken,
                    uitvalt, en meer.
                  </p>
                  <p className="font-bold" data-id="element-2019">
                    Daarom is de oplossing anders dan je denkt.
                  </p>
                  <p className="font-bold" data-id="element-2020">
                    Zodra je de lichaamssignalen van je hond goed begrijpt zie
                    je wat hij denkt, wilt en waar hij stress van krijgt. En als
                    je terug communiceert op een manier die hij van nature
                    begrijpt. Dan raakt je hond veel meer op zijn gemak en zal
                    je zien dat hij naar je luistert.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-2021">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-2022">
                    {[{
                    title: 'Stap 1: Hondentaal',
                    text: 'Leer de subtiele lichaamssignalen van je hond en hoe je ontdekt wat hij je precies probeert te vertellen.'
                  }, {
                    title: 'Stap 2: Terugpraten',
                    text: 'Krijg de tools om in zijn eigen taal terug te communiceren en een sterke, veerkrachtige vertrouwensband te leggen.'
                  }, {
                    title: 'Stap 3: Samenwerken',
                    text: 'Leer hoe je stressvrij en effectief kunt samenwerken, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-2023">
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-2024" />
                        <div data-id="element-2025">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-2026">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-2027">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-2028">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-2029">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-2030">
                    Deze methode is <strong data-id="element-2031">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-2032">
                    Deze methode is <strong data-id="element-2033">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-2034">
                    Als je klaar bent om de cirkel van stress te doorbreken en
                    een diepere band met je hond te krijgen, dan is dit het
                    moment.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-2035">
                    <img src="https://cdn.magicpatterns.com/uploads/7QbopuV5o2pEQqFw8GzzYw/Ontwerp_zonder_titel_(66).png" alt="Amee met hond buiten" className="w-full h-auto object-cover" data-id="element-2036" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-2037">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-2038">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2039">
                  <img src="https://cdn.magicpatterns.com/uploads/7kNRQ43TgkEzcEQikb1C2w/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-2040" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2041">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2042">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-2043">
                    <div className="flex items-start gap-3" data-id="element-2044">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2045" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-2046">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2047">
                      Dit leer je in Stap 1
                    </p>
                    {['Hoezo commanderen geen nut heeft als je niet eerst dezelfde taal spreekt', 'Welke subtiele lichaamssignalen honden gebruiken en wat ze precies betekenen', 'Hoe je de signalen van jouw hond leest zodat je weet wat hij nodig heeft'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-2048">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2049" />
                        <span className="text-sm text-gray-700" data-id="element-2050">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2051">
                      Dit leer je in Stap 2
                    </p>
                    {['Hoe je kalmerende signalen en handgebaren gebruikt om terug te praten', 'Wat je wel, en wat je juist niet moet doen met je lichaamstaal om misverstanden te voorkomen', 'Voorbeeld casus van hond Lemmy en hoe hij van extreem uitvallen naar ontspannen wandelen ging met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe zij hun frustratie in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-2052">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2053" />
                        <span className="text-sm text-gray-700" data-id="element-2054">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2055">
                      Dit leer je in Stap 3
                    </p>
                    {['Effectief samenwerken zodat je op de juiste manier een diepe band opbouwt', 'Drie voorbeeld situaties waarin je de methode in de praktijk brengt'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-2056">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2057" />
                        <span className="text-sm text-gray-700" data-id="element-2058">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2059">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Masterclass hondengeschiedenis. Ontwikkeling van het diersoort en de ontwikkeling van wetenschappelijke onderzoeken en conclusies over hondengedrag.', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-2060">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2061" />
                        <span className="text-sm text-gray-700" data-id="element-2062">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2063">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-2064">
                    Liefdevol Communiceren Pakket Actie
                  </div>
                  <div className="p-5 text-center" data-id="element-2065">
                    <img src="https://cdn.magicpatterns.com/uploads/oEL2JDeiE1fJbhau44wGFR/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-2066" />
                    <div className="text-gray-500 text-sm" data-id="element-2067">
                      <span className="line-through" data-id="element-2068">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-2069">
                      Slechts €127
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-2070">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-2071">
                      Cursus + 2 vrije cursussen + digitaal boek. Direct
                      toegang.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-2072">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-2073">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-2074">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2075">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2076">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2077">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2078">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2079">
                        <Star className="w-4 h-4 fill-current" data-id="element-2080" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2081" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2082" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2083" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2084" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2085">
                        "Sinds we de cursus volgen, is de band met Max zoveel
                        sterker geworden. We begrijpen elkaar eindelijk!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2086">
                        - Lisa & Max
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2087">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2088">
                        <Star className="w-4 h-4 fill-current" data-id="element-2089" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2090" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2091" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2092" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2093" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2094">
                        "Ik dacht dat mijn hond gewoon koppig was, maar dankzij
                        Amee zie ik nu dat hij me iets probeerde te vertellen.
                        Een wereld van verschil."
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2095">
                        - Mark & Bella
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2096">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2097">
                        <Star className="w-4 h-4 fill-current" data-id="element-2098" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2099" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2100" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2101" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2102" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2103">
                        "De rust in huis is teruggekeerd. Geen frustratie meer,
                        maar echte samenwerking. Bedankt!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2104">
                        - Sarah & Luna
                      </p>
                    </div>
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2105">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-2106">
                    Start met het Liefdevol Communiceren Pakket
                  </div>
                  <div className="p-5 text-center" data-id="element-2107">
                    <div className="text-gray-500 text-sm" data-id="element-2108">
                      Totale waarde <span className="line-through" data-id="element-2109">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-2110">
                      Slechts €127 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-2111">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-2112">
                      Inclusief 2 vrije cursussen + digitaal boek "Wat Zegt Jouw
                      Hond?". Direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-2113">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-2114">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2115">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2116">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2117">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Printbare Stappenplannen',
                    desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen om er altijd bij te kunnen pakken.'
                  }, {
                    title: 'Levenslange Toegang',
                    desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates van de cursus.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-2118">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2119" />
                        <div data-id="element-2120">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-2121">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-2122">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2123">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2124">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2125">
                    {['1084982139', '1084982111', '1084982084'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-2126">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-[8/9]" title={`Testimonial ${id}`} data-id="element-2127"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-2128">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-2129">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-2130">
                    Start nu met de Liefdevol Communiceren Methode
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-2131">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2132">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-2133" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-2134">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-2135">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-2136">
            <p data-id="element-2137">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €127 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-2138">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-2139">
              Ik geef je 365 dagen om de Liefdevol Communiceren Cursus te
              bekijken en toe te passen.
            </p>
            <p data-id="element-2140">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €127 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-2141">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-2142">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-2143">
          <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-2144">
            Liefdevol Communiceren Pakket Actie
          </p>
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-2145">
            Vandaag voor €127
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-2146">
            (Bespaar €274)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/9QvtvBrW74TzrCyCAwHwpa/lc_booklet_mockup.png" alt="Liefdevol Communiceren Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-2147" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-2148">
            Start met het complete Liefdevol Communiceren Pakket voor{' '}
            <span className="line-through" data-id="element-2149">€401</span> slechts €127! Inclusief 2
            gratis cursussen naar keuze en het digitale boek "Wat Zegt Jouw
            Hond?". Direct toegang.
          </p>
          <div className="max-w-md mx-auto" data-id="element-2150">
            <CTAButton data-id="element-2151" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-2152">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-2153">
        <div className="max-w-6xl mx-auto px-4" data-id="element-2154">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-2155">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2156">
            {[{
            title: 'Liefdevol Communiceren Cursus',
            desc: 'Volledige training in hoe je de Liefdevol Communiceren Methode inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/pPc7pHdzhv1XesyMhYPzEV/lc_book_mockup.png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Levenslange Toegang',
            desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Printbare Stappenplannen',
            desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-2157">
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-2158">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-2159">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-2160">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-2161" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-2162">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-2163">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-2164">
        <div className="max-w-md mx-auto" data-id="element-2165">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-2166">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-2167">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-2168">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-2169">
          <div className="flex-1 text-center md:text-left" data-id="element-2170">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-2171">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-2172">
              <strong data-id="element-2173">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-2174">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-2175">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-2176" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-2177">
        <div className="max-w-5xl mx-auto px-4" data-id="element-2178">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-2179">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-2180">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vind je drie uitgebreide modules waarin je alles leert over de Liefdevol Communiceren Methode.'
          }, {
            q: 'Wat is de Liefdevol Communiceren Methode?',
            a: 'Dit is een nieuwe methode waarin je de taalbarrière tussen jou en je hond doorbreekt in plaats van je alleen maar te richten op commanderen. Wij gebruiken deze methode om jaarlijks bij honderden honden gedragsproblemen bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: 'Alles wat je kan vinden gaat alleen maar over gehoorzaamheid en correcties. Met deze methode kijk je naar de taal die je hond spreekt, pak je de miscommunicatie bij de kern aan en ga je daarna pas samenwerken. Op deze manier heb je sneller, beter en blijvend resultaat.'
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de gedragsproblemen van hun hond nu voor eens en altijd willen oplossen en dit op een empatische, liefdevolle manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-2181">
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-2182">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-2183" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-2184">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WANDELINGEN-BEELD */}
      <section className="bg-[#faf5eb] py-12" data-id="element-2185">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-2186">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-2187">
            Hoe vaak per dag laat jij je hond uit? Drie keer? Vier keer?
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-2188">
            Dat zijn{' '}
            <span className="font-black text-[#1a2b4a]" data-id="element-2189">
              honderden wandelingen per jaar
            </span>
            . Honderden momenten samen.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-2190">
            Waarom zouden jullie al die momenten doorbrengen met frustratie en
            spanning, als het ook{' '}
            <span className="text-[#5ce0d2] font-bold" data-id="element-2191">
              ontspannen en verbonden
            </span>{' '}
            kan?
          </p>
          <p className="text-lg text-gray-500 mt-6 italic" data-id="element-2192">
            Eén kleine verandering in hoe jij communiceert, verandert élke
            wandeling. Elke ochtend. Elke avond. Voorgoed.
          </p>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-2193">
        <div className="max-w-md mx-auto" data-id="element-2194">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-2195">
            Start met deze cursus
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-2196">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-2197">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-2198">
          <p className="font-bold text-white mb-8" data-id="element-2199">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-2200">
            <p className="font-bold text-white" data-id="element-2201">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-2202">
              Start met de cursus.
            </a>
          </div>

          <p className="text-justify" data-id="element-2203">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-2204">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-2205">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-2206">
            <img src="https://cdn.magicpatterns.com/uploads/kbsUp8Jcv8Ni5jP2oc579N/Ontwerp_zonder_titel_(70).png" alt="Liefdevol Communiceren Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-2207" />
            <img src="https://cdn.magicpatterns.com/uploads/fnqxQ7hwmYLpvvLjHhPAxX/Ontwerp_zonder_titel_(69).png" alt="Liefdevol Communiceren Cursus" className="w-16 md:w-24 h-auto object-contain" data-id="element-2208" />
            <div data-id="element-2209">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-2210">
                Liefdevol Communiceren Cursus
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-2211">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-2212">
                  €197
                </span>
                €127
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-2213">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}